import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-service-request-error',
    templateUrl: './service-request-error.component.html',
    styleUrls: ['./service-request-error.component.scss']
})
export class ServiceRequestErrorComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
